import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from './axiosApi'; 
import authHeader from './authHeader';

export const fileUpload = createAsyncThunk("file/upload", async (payload) => {
  try {
    const response = await apiInstance.post("/upload", payload, {
      headers: authHeader(),
    });
    return response.data; 
  } catch (error) {
    return Promise.reject(error.response.data || error.message);
  }
});

const initialState = {
  file: null,
  isLoading: false,
  error: null,
};

const fileSlice = createSlice({
  name: 'file',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fileUpload.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fileUpload.fulfilled, (state, action) => {
        state.isLoading = false;
        state.file = action.payload.fileUrl || action.payload; 
      })
      .addCase(fileUpload.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'File upload failed'; 
      });
  },
});

export default fileSlice.reducer;
